import { normalizeJob } from '@/composables/useJobPresentation.js'

export async function fetchJobSummaryPage(requestJson, {
  limit = 50,
  cursor,
  group,
  workspaceId,
} = {}) {
  const params = new URLSearchParams({
    pagination: 'cursor',
    limit: String(limit),
  })

  if (cursor) {
    params.set('cursor', cursor)
  }
  if (group && group !== 'all') {
    params.set('group', group)
  }
  if (workspaceId) {
    params.set('workspaceId', workspaceId)
  }

  const data = await requestJson(`/jobs?${params}`)
  const rawItems = Array.isArray(data?.items)
    ? data.items
    : (Array.isArray(data?.jobs) ? data.jobs : [])

  return {
    items: rawItems.map(normalizeJob),
    limit: typeof data?.limit === 'number' && data.limit > 0 ? data.limit : limit,
    hasMore: data?.hasMore === true,
    nextCursor: typeof data?.nextCursor === 'string' ? data.nextCursor : null,
  }
}

export async function fetchAllJobSummaryItems(requestJson, {
  limit = 200,
  maxPages = 25,
  group,
  workspaceId,
} = {}) {
  const items = []
  let cursor = undefined
  let pages = 0

  while (pages < maxPages) {
    pages += 1
    const page = await fetchJobSummaryPage(requestJson, {
      limit,
      cursor,
      group,
      workspaceId,
    })

    items.push(...page.items)

    if (!page.hasMore || !page.nextCursor) {
      return items
    }

    cursor = page.nextCursor
  }

  throw new Error(`Run summary pagination exceeded ${maxPages} pages`)
}
